import { AllIcons } from 'shared/ui/app-icon/types'

export const isValidIcon = (icon: AllIcons): boolean => {
  return Object.values(AllIcons).includes(icon)
}

export const getValidIcon = (icon: AllIcons): AllIcons => {
  return isValidIcon(icon) ? icon : AllIcons.CHECK_MARK
}
